// Переключатель дизайна: classic (по умолчанию) / cp. Старая версия — line-numbers.styled.classic.js, новая — line-numbers.styled.cp.js
import { isCp } from 'libs/design';
import * as classic from './line-numbers.styled.classic';
import * as cp from './line-numbers.styled.cp';

export const Content = isCp ? cp.Content : classic.Content;
